import Vue from 'vue'
import Router from 'vue-router'
import store from "./store";

import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
import Fullscreen from '@/layout/Fullscreen'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: "active",

    routes: [
        {
            path: '/',
            redirect: '/',
            component: Fullscreen,
            children: [
                {
                    path: '/',
                    name: 'verify code',
                    component: () => import( './views/Home.vue'),
                    meta: {requiresAuth: false, role: []}
                }
            ]
        },
        {
            path: '/',
            redirect: 'login',
            component: AuthLayout,
            children: [
                {
                    path: '/login',
                    name: 'login',
                    component: () => import( './views/Login.vue'),
                    meta: {requiresAuth: false, role: []}
                }
            ]
        },
        {
            path: '/',
            redirect: 'code',
            component: DashboardLayout,
            children: [
                {
                    path: '/code',
                    name: 'code',
                    component: () => import( './views/Code/Code.vue'),
                    meta: {requiresAuth: true, role: ['admin']}
                },
                {
                    path: '/code/generate',
                    name: 'generate code',
                    component: () => import( './views/Code/Add.vue'),
                    meta: {requiresAuth: true, role: ['admin']}
                },
                {
                    path: '/background',
                    name: 'background',
                    component: () => import( './views/Background'),
                    meta: {requiresAuth: true, role: ['admin']}
                },
                {
                    path: '/setting',
                    name: 'setting',
                    component: () => import( './views/Setting.vue'),
                    meta: {requiresAuth: true, role: ['admin']}
                },
            ]
        },
        {path: '*', redirect: '/'},
    ]
});


router.beforeEach(async (to, from, next) => {
    let currentUser = store.state.auth;
    if (to.meta.requiresAuth && !currentUser.isLogged) {
        next({path: '/login'});
    } else {
        if (to.meta.role.indexOf('admin') !== -1) {
            if (store.state.auth.user.role === 'admin') {
                next();
            } else {
                next({path: '/'});
            }
        } else {
            next();
        }
    }
});


export default router;
